import { createFileRoute } from "@tanstack/react-router";
import AdminOrganizationsPage from "@/pages/admin/organizations";

export const Route = createFileRoute("/app/admin/organizations")({
  component: AdminOrganizationsPage,
});
